import { connect } from 'react-redux'
import Dashboard from './Dashboard'
import { getNumbers } from 'features/Numbers/Numbers.actions'
import { getBills } from 'features/Billing/Billing.actions'
import { getCases, getOutages } from 'features/Cases/Cases.actions'

const stateToProps = ({ auth, billing, cases, numbers }) => ({
  user: auth.user,
  services: numbers.numbers.map(numberId => numbers.numbersById[numberId]),
  bills: billing.bills,
  billingAccounts: billing.billingAccounts || [],
  billsLoading: billing.billsLoading,
  cases: cases.cases
    .map(item => cases.casesById[item])
    .filter(item => item.recordType !== 'Product Order'),
  getCasesLoading: cases.getCasesLoading,
})

const dispatchToProps = {
  getNumbers,
  getBills,
  getCases,
  getOutages,
}

export default connect(stateToProps, dispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.container.js